// Pure textarea primitive - no form/business logic
import { forwardRef, type TextareaHTMLAttributes } from 'react';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ error, className = '', ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={`textarea w-full rounded-lg bg-[#3A3A3A] border border-white/10 text-[#F9F9F9] placeholder:text-[#CACACA] focus:outline-none focus:border-white/20 ${error ? 'textarea-error' : ''} ${className}`.trim()}
        {...props}
      />
    );
  }
);

TextArea.displayName = 'TextArea';
